// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AddressOverviewTileComponent from '../views';
import {
  getAddressListState,
  getAddressListFetchingState,
} from '../../../../AddressBook/container/AddressBook.selectors';
import { getAddressList } from '../../../../AddressBook/container/AddressBook.actions';
import AddressOverviewTileSkelton from '../skelton/AddressOverviewTileSkelton.view';

export class AddressOverviewTile extends React.PureComponent {
  render() {
    const { addressList, handleComponentChange, isFetching } = this.props;

    if (isFetching) {
      return <AddressOverviewTileSkelton />;
    }

    const filterAddresses = () => {
      return addressList?.filter(
        (address) => address?.countryCode === 'US' || address?.countryCode === 'CA'
      );
    };

    const filteredShippingAddressList = filterAddresses();

    return (
      <AddressOverviewTileComponent
        addressList={addressList}
        handleComponentChange={handleComponentChange}
        filteredShippingAddressList={filteredShippingAddressList}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    addressList: getAddressListState(state),
    isFetching: getAddressListFetchingState(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getAddressListAction: () => {
      dispatch(getAddressList());
    },
  };
};

AddressOverviewTile.propTypes = {
  getAddressListAction: PropTypes.func.isRequired,
  addressList: PropTypes.shape({}),
  handleComponentChange: PropTypes.func,
  isFetching: PropTypes.bool,
};

AddressOverviewTile.defaultProps = {
  addressList: {},
  handleComponentChange: () => {},
  isFetching: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressOverviewTile);
